webpackJsonp([257680017402065],{

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(16);
	
	var _theme = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Title = __webpack_require__(26);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailsContainer = (0, _styledComponents2.default)(_rebass.Box).withConfig({
	  displayName: 'values__DetailsContainer',
	  componentId: 'sc-1qdmm92-0'
	})(['font-family:', ';font-size:', ';&:first-letter{font-weight:bold;font-size:', ';}color:', ';'], _theme.fonts.secondary, _theme.fontSizes[3] + 'px', _theme.fontSizes[6] + 'px', _theme.colors.greyDark);
	var TextSeparator = (0, _styledComponents2.default)(_rebass.Divider).withConfig({
	  displayName: 'values__TextSeparator',
	  componentId: 'sc-1qdmm92-1'
	})(['width:30px;height:5px;background-color:', ';border-bottom:none;border-radius:15px;position:relative;left:50%;transform:translateX(-50%);'], _theme.colors.secondary);
	var Values = function Values() {
	  return _react2.default.createElement(
	    _rebass.Box,
	    { px: 5, py: 6, style: { textAlign: 'center' } },
	    _react2.default.createElement(
	      _Title2.default,
	      { color: _theme.colors.primary },
	      'Our Approach'
	    ),
	    _react2.default.createElement(TextSeparator, null),
	    _react2.default.createElement(
	      DetailsContainer,
	      null,
	      'We help our clients solve complex business problems and use our experience, talent and business understanding to create value for them. We focus on relationships with our clients as much as client delivery. We invest time in understanding our clients and their businesses in order to ensure quality advice and timely delivery. The Partners and Senior Advisors at the Firm lead delivery of all services to ensure that client expectations are met.'
	    ),
	    _react2.default.createElement(_rebass.Divider, { pt: 3, mb: 5 }),
	    _react2.default.createElement(
	      _Title2.default,
	      { color: _theme.colors.primary },
	      'Our Values'
	    ),
	    _react2.default.createElement(TextSeparator, null),
	    _react2.default.createElement(
	      DetailsContainer,
	      null,
	      'We strive for excellence and follow the best industry practices and high quality standards in client delivery and service. We adhere strictly to client confidentiality standards. We are committed to integrity and fairness in our approach including all interaction and dealings with clients'
	    )
	  );
	};
	
	exports.default = Values;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-values-js-1d6d79536178665db32e.js